export default __webpack_public_path__ + "static/media/banner.904e5582.png";